import { _freeze, } from '../util/data';
import { _$, } from '../util/dom';
import { _currentUnitAbbr, _currentUnitConversion, } from './distance-units';
const _routeLength = (route) => {
    const routeId = route.p().id(), displayId = `ld-${routeId}`, buttonId = _ldButtonId(routeId), outputId = `ldo-${routeId}`, $ldButton = _$(['input',
        { type: 'radio', name: _ldButtonName, id: buttonId, value: routeId }]), $ldOutput = _$(['output', { id: outputId }, '0']), $ldUnitOutput = _$(['output', { class: _lengthUnitClass },
        _currentUnitAbbr()]), $ldLabelSpan = _$(['span', {}, $ldOutput, ' ', $ldUnitOutput]), $ldLabel = _$(['label', { for: buttonId }, $ldLabelSpan]), $lengthDisplay = _$(['p', { id: displayId, 'data-ld': '' },
        $ldButton, $ldLabel]), routeLength = _freeze({
        get: () => lengthValue,
        r: () => route,
        d: () => $lengthDisplay,
        set: () => {
            lengthValue = _calculateRouteLength(routeLength);
            _updateLengthDisplay(lengthValue, $ldOutput);
            return routeLength;
        },
        add: (change) => {
            lengthValue += change;
            _updateLengthDisplay(lengthValue, $ldOutput);
            return routeLength;
        },
        setU: () => {
            $ldUnitOutput.value = _currentUnitAbbr();
            _updateLengthDisplay(lengthValue, $ldOutput);
            return routeLength;
        },
    });
    let lengthValue = 0;
    routeLength.set();
    return routeLength;
}, _updateLengthDisplay = (lengthValue, $output) => {
    const displayLength = _routeDisplayLength(lengthValue, _currentUnitConversion());
    $output.value = displayLength;
}, _displayLength = (fractionDecimals) => {
    const displayDecimalsMultiplier = Math.pow(10, fractionDecimals);
    return (lengthInBaseUnits, baseUnitsPerDisplayUnit) => {
        const lengthInDisplayUnits = lengthInBaseUnits / baseUnitsPerDisplayUnit, integerPart = Math.floor(lengthInDisplayUnits), fractionalPart = lengthInDisplayUnits - integerPart, fractionInt = Math.floor(fractionalPart * displayDecimalsMultiplier), paddedFraction = fractionInt.toString().padStart(fractionDecimals, '0');
        return `${integerPart}.${paddedFraction}`;
    };
}, _fractionDecimals = 4, _routeDisplayLength = _displayLength(_fractionDecimals), _calculateRouteLength = (routeLength) => {
    let route = routeLength.r(), length = 0, currentPoint = route.s(), currentLine = currentPoint.ol();
    while (currentLine) {
        length += currentLine.len();
        currentPoint = currentLine.ep();
        currentLine = currentPoint.ol();
    }
    return length;
}, _ldButtonId = (routeId) => `ldb-${routeId}`, _lengthUnitClass = 'rm-length-unit', _ldButtonName = 'rm-ld';
export { _routeLength, _ldButtonId, };
